import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import userAxios from '../../../../utils/axios/user.axios';

const tryToUploadFiles = (data: FormData): Promise<AxiosResponse<any>> => {
    const url = `${USERS_API_URL}/hotel-world-user-invites/upload-chat-files`
    return userAxios.post(url, data);
};

const tryToUploadKnowledgeFiles = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${USERS_API_URL}/ai-agents/knowledge-base/upload`
    return userAxios.post(url, data);
};

const tryToDeleteKnowledgeFile = (id: string): Promise<AxiosResponse<any>> => {
    return userAxios.delete(`${USERS_API_URL}/ai-agents/knowledge-base/${id}`);
};

const tryToFetchKnowledgeFiles = (): Promise<AxiosResponse<any>> => {
    return userAxios.get(`${USERS_API_URL}/ai-agents/knowledge-base`);
};

export const KnowledgeFilesService = {
	tryToUploadFiles,
    tryToUploadKnowledgeFiles,
    tryToDeleteKnowledgeFile,
    tryToFetchKnowledgeFiles,
};